module.exports = __webpack_public_path__ + "img/gangqin_20210901113816.dd8cb555.png";